//// USER ADDITIONAL INFORMATIONS
export const FETCH_USERS_INFO = "FETCH_USERS_INFO"
export const FETCH_USER_INFO = "FETCH_USER_INFO"
export const CHANGE_AUTH_USER_INFO = "CHANGE_AUTH_USER_INFO"

//
export const SHOW_LOGIN_DIALOG = "SHOW_LOGIN_DIALOG"

//LOGIN
export const FETCH_USER = "FETCH_USER"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGIN_USER_NOT_FOUND = "LOGIN_USER_NOT_FOUND"
export const LOGIN_INCORRECT_CREDENTIALS = "LOGIN_INCORRECT_CREDENTIALS"
export const LOGIN_PASSWORD_RESET = "LOGIN_PASSWORD_RESET"


//REGISTRATION
export const REGISTER_SUCCESS = "REGISTER_SUCCESS"

//Subscribers
export const FETCH_ALL_SUBSCRIBERS = "FETCH_ALL_SUBSCRIBERS"

//ORDERS
export const SHOW_ORDER_DIALOG = "SHOW_ORDER_DIALOG"
export const ORDER_COMMITED = "ORDER_COMMITED"
export const FETCH_ALL_ORDERS = "FETCH_ALL_ORDERS"
export const FETCH_USER_ORDERS = "FETCH_USER_ORDERS"
export const FETCH_USER_HISTORY_ORDERS = "FETCH_USER_HISTORY_ORDERS"
export const FETCH_ALL_HISTORY_ORDERS = "FETCH_ALL_HISTORY_ORDERS"


/// PRODUCTS
export const FETCH_ALL_PRODUCTS = "FETCH_ALL_PRODUCTS"
export const GET_PRODUCT_BY_ID = "GET_PRODUCT_BY_ID"
export const UPDATE_PRODUCT = "UPDATE_PRODUCT"
export const DELETE_PRODUCT = "DELETE_PRODUCT"

// USERS UNITS
export const FETCH_USERS_UNITS =  "FETCH_USERS_UNITS"
export const FETCH_USER_UNITS =  "FETCH_USER_UNITS "


// SPORTS
export const FETCH_ALL_SPORTS = "FETCH_ALL_SPORTS"

// PARTICIPANTS
export const FETCH_SPORT_PARTICIPANTS = "FETCH__SPORT_PARTICIPANTS"

// SPORT SPORT EVENTS
export const FETCH_SPORT_EVENTS = "FETCH__SPORT_EVENTS"

// BETS
export const FETCH_PREMIUM_BETS = "FETCH_PREMIUM_BETS"
export const FETCH_BETS_HISTORY = "FETCH_BETS_HISTORY"

// STATISTIC
export const FETCH_PACKAGE_STATISTIC = "FETCH_PACKAGE_STATISTIC"
export const FETCH_STATISTIC = "FETCH_STATISTIC"
export const FETCH_STATISTIC_MONTH = "FETCH_STATISTIC_MONTH"

// FREE BETS PAGE
export const FETCH_FREE_BET_PAGE  = "FETCH_FREE_BET_PAGE"

// NAVIGATION
export const ACTIVE_NAV_LINK  = "ACTIVE_NAV_LINK"

// BET ADVICES
export const FETCH_BET_VIDEOS = "FETCH_BET_VIDEOS"

// FCM SUBSCRIPTION
export const FETCH_FCM_USER_SUBSCRIPTIONS = "FETCH_FCM_USER_SUBSCRIPTIONS"
export const UPDATE_FCM_USER_SUBSCRIPTIONS = "UPDATE_FCM_USER_SUBSCRIPTIONS"
export const SET_DEVICE_FCM_TOKEN = "SET_DEVICE_FCM_TOKEN"
export const DEVICE_FCM_TOKEN_SUPORTED = "DEVICE_FCM_TOKEN_SUPORTED"


// WEBPAGE VARIABLES
export const DISPLAY_INFO_DATA = "DISPLAY_INFO_DATA"
export const SHOW_USER_AGREEMENT = "SHOW_USER_AGREEMENT"

export const TRANSACTION_START = "TRANSACTION_START"
export const TRANSACTION_END = "TRANSACTION_END"
export const MONETA_TRANSACTION_STATUS = "MONETA_TRANSACTION_STATUS"


export const SHOW_COOKIES_INFO = "SHOW_COOKIES_INFO"



// WEBPACK FOOTER //
// ./src/actions/types.js